var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnflate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 304.2 57.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#3a1772;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 34.85,
    x2: 94.08,
    y2: 34.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ec4e20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a1772"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.48,35.28h-37.92v22.32h-5.76V21.24c0-4.98,4.02-9,9-9h34.68v5.76h-37.92v11.52h37.92v5.76Zm10.8,10.08h-5.76V0h5.76V45.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.08,45.36h-36.24c-4.98,0-9-4.02-9-9v-1.44c0-4.98,4.02-9,9-9h30.48v-7.92h-37.92v-5.76h34.68c4.98,0,9,4.02,9,9v24.12Zm-5.76-5.76v-7.92h-33.72v7.92h33.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.48,45.36h-34.68c-4.98,0-9-4.02-9-9V0h5.76V12.24h37.92v5.76h-37.92v21.6h37.92v5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.2,45.36h-34.68c-4.98,0-9-4.02-9-9v-15.12c0-4.98,4.02-9,9-9h25.68c4.98,0,9,4.02,9,9v10.44h-37.92v7.92h37.92v5.76Zm-5.76-19.44v-7.92h-32.16v7.92h32.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.08,21.24c0-4.98-4.02-9-9-9H50.4v27.36H5.76V18H37.92v7.92H19.24v-4.25h-5.81v10.01h3.67s26.58,0,26.58,0v-10.44c0-4.98-4.02-9-9-9H9C4.02,12.24,0,16.26,0,21.24v15.12c0,4.98,4.02,9,9,9H56.16V18h32.16v22.58h-.01v16.88h5.76v-12.1h.01V21.24Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnflate);
export default __webpack_public_path__ + "static/media/Enflate.32555a227995b8f8a7f401318b157e0d.svg";
export { ForwardRef as ReactComponent };